import OnboardingForm from 'src/components/Forms/OnboardingForm';

const OnboardingPage = () => (
  <>
    <OnboardingForm />
  </>
);
export default OnboardingPage;
